import React from 'react';
import {Button, Grid} from '@mui/material';
import CircularProgress from '@mui/material/CircularProgress';
import {DefaultShortcuts, type ShortcutCommand} from 'services/shortcuts/types';
import {useLocalization} from 'localization';
import {
  mapToShortcut,
  useShortcutUserPreference,
  useShortcutUserPreferenceMutation,
} from 'services/shortcuts';
import {Icon} from 'components/icons';
import {KeyRecordInput} from './KeyRecordInput';

type Props = {
  command: ShortcutCommand;
};

export const EditCommand: React.FC<Props> = ({command}) => {
  const {t} = useLocalization();

  const defaultValue = DefaultShortcuts[command];

  const {userPreference} = useShortcutUserPreference(command, defaultValue);
  const {isSuccess, isError, isLoading, onMutate} =
    useShortcutUserPreferenceMutation(command, defaultValue);

  return (
    <Grid container spacing={2}>
      <Grid alignItems={'flex-end'}>
        <KeyRecordInput
          name={command}
          label={t(`shortcuts.${command}.label`)}
          onChange={onMutate}
          currentShortcut={
            userPreference.value ? userPreference.value : '<Usatt>'
          }
          readonly={isLoading}
        />
      </Grid>
      <Grid size={1} alignItems={'flex-end'} alignContent={'flex-end'}>
        {isLoading ? (
          <CircularProgress />
        ) : isError || isSuccess ? (
          <Icon
            icon={isError ? 'Remove' : 'Check'}
            color={isError ? 'error' : 'success'}
          />
        ) : null}
      </Grid>
      <Grid alignItems={'flex-end'} alignContent={'flex-end'}>
        {defaultValue && defaultValue !== userPreference.value && (
          <Button onClick={() => onMutate(mapToShortcut(defaultValue))}>
            {`${t('general.reset')} til "${defaultValue}"`}
          </Button>
        )}
      </Grid>
    </Grid>
  );
};
